<template>
    <section  v-if="hasPermissions(['Building-Department Write', 'Building-Department Read', 'Building-Department Department-Upload'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of all Departments within your Facility. Click "Add Department" to create a new Department. Clicking "Mass Delete" will delete the Department and all Rooms within the Department. You must create a Cost Center before you create a Department.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="departments.length && hasPermissions(['Building-Department Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>

            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'departments_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Building-Department Department-Upload'])"
                />
                <button v-if="hasPermissions(['Building-Department Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>

            <div v-if="hasPermissions(['Building-Department Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

         <div class="tab-content" v-show="departments.length && hasPermissions(['Building-Department Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="departments"
                                :search="search"
                                :checkable="true"
                                :link="'#'"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Department'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Department Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'departments_falied_template_file'"
        />

        <HelperModal :helps="helps"/>

  </section>
  <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
 </div>
</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import HelperModal          from    '@/components/HelperModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DinamicTable         from    '@/components/DinamicTable'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'

import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'CostCenterDepartment',

    components:{
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal,
        DinamicTable,
        DeletionMassiveModal,
        UploadOptions,
        UploadSummary,
        UnauthorizedComponent,
        HelperModal
    },

    data(){
        return {
            notyf,
            child_href:             '/building-department/',
            axios,
            title_page:             'Cost Center Departments',
            content_header:         this.$store.state.headers,
            rest_api:               `${this.$store.state.route_api_rest}departments`,
            notifications:          this.$store.state.form_notyf,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            excel_file_headers:     Resources.excel_file_headers,
            empty_format_data:      Resources.empty_format_data,
            excel_fields_required:  Resources.excel_fields_required,
            add_btn:                'Add Department',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           0,
            single_object:          {},
            departments:            [],
            array_options:          {},
            select_ids:             [],
            summary:                [],
            excel_data:             [],
            helps:                  Resources.helps
        }
    },
    
    methods:{
        unshift_object(new_object){
        this.departments.unshift(new_object)
      },

      splice_object(splicing_object){
        this.departments.splice(splicing_object.index, 1, splicing_object.single_object)
      },

      form_modal(){
        window.$('#static').modal('show')
      },

      modal_deletion(index){
        this.global_index  = index
        this.single_object = this.departments[index]
        window.$('#static-deletion').modal('show')
      },

      modal_update(index){
        this.global_index  = index
        this.single_object = {...this.departments[index]}
        
        window.$('#static-update').modal('show')
      },

        fill_data(data) {
            this.departments = data.departments
            this.array_options = {
                cost_center_id: data.cost_centers
            }
        },

        trashing(index){
            this.departments.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.departments.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.departments.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.departments.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        async upload(data)
        {
            const send_data = []
            this.excel_data = []

            for ( const value of data ) 
            {
                const entity = {}

                for (const prop in this.excel_file_headers)
                {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }

                this.excel_data.push({... entity})

                const cost_center = this.array_options.cost_center_id.find(item => item.name == entity.cost_center_id)
                entity.cost_center_id = cost_center ? cost_center.id : undefined

                send_data.push(entity)
            }
            
            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { departments: send_data })
            this.loader()

            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                for (const department of response.data.departments) 
                {
                    this.unshift_object(department);
                }
            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel.clear_data()
        },
    },

    async mounted()
    {
        if(this.hasPermissions(['Building-Department Write', 'Building-Department Read', 'Building-Department Department-Upload']))
        {
            await this.api_request()
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.departments.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}

</script>